import React from 'react'
import RehypeReact from 'rehype-react'

import { 
  Anchor,
  Choice,
  Choose,
  CTA, 
  BlogCards,
  Centered,
  Dark,
  Download,
  GuideCategories,
  Grid,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Header,
  Hero,
  Highlight,
  ImageFrame,
  Banner,
  BannerTitle,
  HorizontalList,
  LoggedIn,
  LoginButton,
  Message, 
  Next,
  More,
  Observe,
  Observer,
  Pre,
  Postman,
  ReferenceCategories,
  ResetButton,
  Samples, 
  SDK,
  SDKS,
  Store,
  Trigger,
  Table,
  YouTube,
} from '~components/Markdown'

import { Tabs, Tab } from '~components/Tabs'

const components = { 
  'a': Anchor,
  'banner': Banner,
  'bannertitle': BannerTitle,
  'blogcards': BlogCards,
  'centered': Centered,
  'choice': Choice,
  'choose': Choose,
  'cta': CTA,
  'dark': Dark,
  'download': Download,
  'grid': Grid,
  'guidecategories': GuideCategories,
  'h': Highlight,
  'h1': H1,
  'h2': H2,
  'h3': H3,
  'h4': H4,
  'h5': H5,
  'h6': H6,
  'header': Header,
  'hero': Hero,
  'horizontallist': HorizontalList,
  'imageframe': ImageFrame,
  'loggedin': LoggedIn,
  'loginbutton': LoginButton,
  'message': Message,
  'more': More,
  'next': Next,
  'observe': Observe,
  'observer': Observer,
  'postman': Postman,
  'pre': Pre,
  'referencecategories': ReferenceCategories,
  'resetbutton': ResetButton,
  'samples': Samples,
  'sdk': SDK,
  'sdks': SDKS,
  'store': Store,
  'tab': Tab,
  'table': Table,
  'tabs': Tabs,
  'trigger': Trigger,
  'youtube': YouTube
}

export const recognizedCompontents = components

export const render = (ast) => {
  const rehype = new RehypeReact({
    createElement: React.createElement,
    components: components,
  }).Compiler

  return rehype(ast)
}
export const plainRender = (ast) => {
  const rehype = new RehypeReact({
    createElement: React.createElement
  }).Compiler

  return rehype(ast)
}
